import $ from "jquery";
import debug from "debug";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-header-controller]";
const PLUGIN_NAME = "headerController";

const log = debug("site-header/header-controller:header");

function truthy(value) {
	return value;
}

function uniqueOnly(value, index, self) {
	return self.indexOf(value) === index;
}

function getOverlaySelector(opener) {
	return opener.dataset["headerController-UseOverlay"];
}

function findElement(selector) {
	return document.querySelector(selector);
}

class HeaderController {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.collapsibles = [
			...this.element.querySelectorAll(this.options.collapsibleSelector),
		];
		this.overlays = this.collapsibles
			.map(getOverlaySelector)
			.filter(uniqueOnly)
			.filter(truthy)
			.map(findElement);

		this.watch();

		log("ready", this, this.$target);
	}

	watch() {
		log("watching");

		this.element.addEventListener(
			this.options.childOpenedEvent,
			this.handleOpening.bind(this)
		);
		this.element.addEventListener(
			this.options.childClosedEvent,
			this.handleClosing.bind(this)
		);
		this.element.addEventListener(
			this.options.closeAllEvent,
			this.closeAllCollapsibles.bind(this)
		);

		if (this.options.closeWithDocumentClick) {
			document.addEventListener('click', this.handleDocumentClick.bind(this));
		} else {
			// Overlays only need click events if document is capturing
			this.overlays.forEach(this.bindOverlay.bind(this));
		}
	}

	bindOverlay(element) {
		element.addEventListener("click", this.closeAllCollapsibles.bind(this));
	}

	closeAllCollapsibles() {
		this.collapsibles.forEach((item) => {
			const collapseStateAttr =
				item.dataset["headerController-Collapsible"];
			item.dataset[collapseStateAttr] = false;
		});
		this.hideAllOverlays();
	}

	closeOtherCollapsibles(opener) {
		const toCollapse = this.collapsibles.filter(function (item) {
			return item !== opener;
		});

		toCollapse.forEach((item) => {
			const collapseStateAttr =
				item.dataset["headerController-Collapsible"];
			item.dataset[collapseStateAttr] = false;
		});
	}

	handleDocumentClick(event) {
		if (!this.isWithinCollapsible(event.target)) {
			this.closeAllCollapsibles();
		}
	}

	isWithinCollapsible(element) {
		return this.collapsibles.some((container)=>{
			return container === element || container.contains(element);
		});
	}

	handleOpening(event) {
		const opener = event.target;

		// Only respond to specified collapsibles
		if (!this.collapsibles.includes(opener)) {
			return false;
		}
		this.closeOtherCollapsibles(opener);
		this.displayOverlay(opener);
	}

	// Presumes the closing event is called only when the collapsible closes itself
	//	Not when it is closed externally
	handleClosing(event) {

		// Only respond to specified collapsibles
		if (!this.collapsibles.includes(event.target)) {
			return false;
		}

		this.hideOverlay(event.target);
	}

	// display specified overlay
	displayOverlay(opener) {
		const selector = getOverlaySelector(opener);
		const overlay = document.querySelector(selector);

		if (overlay) {
			overlay.hidden = false;
			this.hideOtherOverlays(overlay);
		} else {
			this.hideAllOverlays();
		}
	}

	hideOverlay(opener) {
		const selector = getOverlaySelector(opener);
		const overlay = document.querySelector(selector);

		if (overlay) {
			overlay.hidden = true;
		}
	}

	hideOtherOverlays(overlay) {
		const overlaysToHide = this.overlays.filter((element) => (element !== overlay));
		overlaysToHide.forEach((element) => (element.hidden = true));
	}

	// Hide all overlays
	hideAllOverlays() {
		this.overlays.forEach((element) => (element.hidden = true));
	}
}

HeaderController.DEFAULTS = {
	childOpenedEvent: 'collapsibleOpened',
	childClosedEvent: 'collapsibleClosed',
	closeAllEvent: 'closeCollapibles'
};

plugin(PLUGIN_NAME, HeaderController);

$(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/site-header/index.js